<div [class]="'sidenav-item ' + status">

  <div (click)="sidenavClicked()">
    <div class="d-flex justify-content-center">
      <i [class]="icon + ' iconText'"></i>
    </div>

    <div class="d-flex justify-content-center">
      <span class="itemText mb-3">{{text}}</span>
    </div>
  </div>

  <div *ngIf="expand">
    <div *ngIf="isSelected">
      <div class="d-flex justify-content-center">
        <i class="fa fa-chevron-up expand"></i>
      </div>
    </div>

    <div *ngIf="!isSelected">
      <div class="d-flex justify-content-center">
        <i class="fa fa-chevron-down expand"></i>
      </div>
    </div>

    <div class="expand-container" [style.height]="submenuOpen">
      <div *ngFor="let data of expand; let i = index" [attr.data-index]="i">
        <ng-container
                *ngIf="data !== undefined && data !== null && (data.visible === undefined || data.visible === true)">

          <div *ngIf="!data.isSelected"
               (click)="subSidenavClicked(data.id)"
               class="d-flex justify-content-center expand-item-passive">
            <span class="expand-text">{{data.text}}</span>
          </div>

          <div *ngIf="data.isSelected && i > 0"
               (click)="subSidenavClicked(data.id)"
               class="d-flex justify-content-center expand-item-active">

            <span class="expand-text">{{data.text}}</span>
          </div>
          <div *ngIf="data.isSelected && i == 0"
               (click)="subSidenavClicked(data.id)"
               class="d-flex justify-content-center expand-item-active"
               style="
              -webkit-box-shadow: inset 0px 9px 10px -5px rgba(0, 0, 0, 0.40);
              -moz-box-shadow: inset 0px 9px 10px -5px rgba(0, 0, 0, 0.40);
              box-shadow: inset 0px 9px 10px -5px rgba(0, 0, 0, 0.40);">

            <span class="expand-text">{{data.text}}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
